// components/SuspenseLoader.js
import { useEffect } from "react";
import NProgress from "nprogress";

const SuspenseLoader = () => {
    useEffect(() => {
        NProgress.start();
        return () => {
            NProgress.done();
        };
    }, []);

    return (
        <div style={{ textAlign: "center", marginTop: "100px" }}>
            <h2>Loading...</h2>
        </div>
    );
};

export default SuspenseLoader;
